import { render, staticRenderFns } from "./WomenArchivePage.vue?vue&type=template&id=0327eec6&scoped=true&"
import script from "./WomenArchivePage.vue?vue&type=script&lang=js&"
export * from "./WomenArchivePage.vue?vue&type=script&lang=js&"
import style0 from "./WomenArchivePage.vue?vue&type=style&index=0&id=0327eec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0327eec6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
